export default "__VITE_ASSET__Bnix3f6r__"